<template>
  <div>
    <!-- loading do kanban -->
    <v-layout align-center justify-center>
      <v-progress-linear
        v-if="loading"
        :size="70"
        :width="7"
        color="#00acc2"
        indeterminate
      ></v-progress-linear>
    </v-layout>
    <!-- utilização do vue draggable para arrastar ordem dos status para que o usuario possa montar a ordem de acordo com seu fluxo de produção -->
    <draggable @end="saveOrder" id="outer" v-model="allStatus" v-bind="dragOptions" draggable=".content_kanban" handle=".handle" class="list_container" :style="`height: ${heightCardTask + 5}px !important;`">
      <!-- area de montagem de cada um dos status onde é utilizado o componente de lista dentro de cada um dos componentes do kanban -->
        <div class="content_kanban" v-for="status in allStatus" :class="status.expanded ? 'xs3' : 'xs1'" :key="status.id_text">
          <!-- // V-if  (showFinalized ? true : status.id_text !== 'Finalizada') incluido pois quando a opção listar finalizadas estiver desmarcado, esconder o quadro de finalizadas -->
          <div v-if="status.expanded && (showFinalized ? true : status.identifier != 3)" class="item_direction" :style="`width: 320px !important;border-color: ${status.color ? status.color : '#00acc2'};`">
            <v-layout align-center justify-space-between row fill-height>
              <v-flex shrink>
                <v-btn icon @click="expandToggle(status)">
                  <v-icon>expand_less</v-icon>
                </v-btn>
              </v-flex>
              <v-flex grow class="handle">
                <h3 class="text-sm-center">{{status.id_text | formatAbbreviation(20)}}</h3>
              </v-flex>
              <v-flex shrink class="handle">
                <v-icon >view_week</v-icon>
              </v-flex>
            </v-layout>
            <hr>
            <v-layout align-center justify-space-between>
              <div style="margin-left: 7px;">
                <v-tooltip bottom>
                  <v-chip slot="activator" outline :color="`${status.color ? status.color : '#00acc2'}`" small text-color="white">
                    <v-avatar :color="`${status.color ? status.color : '#00acc2'}`">{{status.total}}</v-avatar>
                    <v-icon :color="`${status.color ? status.color : '#00acc2'}`">list</v-icon>
                  </v-chip>
                  <span> Total de tarefas </span>
                </v-tooltip>
              </div>
              <v-tooltip bottom :disabled="status['company_id'] == $auth.user().company_id">
                <v-btn color="#00acc2" slot="activator" :disabled="status['company_id'] != $auth.user().company_id"  small @click="openAddProcess(status)" :loading="loadingAddTask" class="mb-0 white--text">adicionar</v-btn>
                <span>Não é possível adicionar tarefas com status de outra empresa.</span>
              </v-tooltip>
            </v-layout>
            <p-task-list :style="`height:${heightCardTask - 90}px !important;`"
            :statusId="status.id"
            :ref="`list${status.id}`"
            :dontShowSubtasks="true"
            @changeTaskList="val => status.items = val"
            @reloadFilter="() => {}" 
            @statusFinalized="val => finalizeTask(val)"
            @changeAllItem="() => {}" 
            @createSubItem="() => {}"
            @taskRemoved="status.total = status.total - 1"
            @duplicateTask="duplicateTask" 
            @editSubItem="editSubItem" 
            @changeStatus="(val) => {changeStatusProcess(val, status)}" 
            @doneNewTask="(val) => {insertTask(val)}" 
            @deleteSubItem="deleteSubItem"
            @openDocumentPreviewList="(taksId, tasktemplateId) => $emit('openDocumentPreviewList', taksId, tasktemplateId)"
            :isMobileDesign="true"
            :taskLoader="status.loading" 
            mouseCursorItem="grab"
            idTaskMother=""
            :hideAddSubtask="true"
            :allTasks="status.items"
            :totalTasks="status.total" 
            @clickMoreTask="() => {statusChangePage(status, true)}" 
            :showCircleInfo="false">
            </p-task-list>
          </div>
          <div v-else-if="(showFinalized ? true : status.identifier != 3)" class="item_direction" :style="`width: 50px !important;border-color: ${status.color ? status.color : '#00acc2'};`">
            <v-layout :style="`height: ${heightCardTask - 5}px ;width: 50px !important;`"  align-center justify-start column>
              <v-btn icon @click="expandToggle(status)">
                <v-icon>expand_more</v-icon>
              </v-btn>
              <v-icon class="handle">view_week</v-icon>
              <v-tooltip bottom>
                <v-avatar slot="activator" size="24" :color="`${status.color ? status.color : '#00acc2'}`"><span class="white--text">{{status.total}}</span></v-avatar>
                <span> Total de tarefas </span>
              </v-tooltip>
              <h3 style="transform: rotate(90deg);white-space: nowrap;margin-top: 75px;">{{status.id_text | formatAbbreviation(20)}}</h3>
            </v-layout>
          </div>
        </div>
    </draggable>
  </div>
</template>

<script>
  /* eslint-disable eqeqeq */
  import methodTaskSocket from './../mixin/methodTaskSocket'
  import stopWatch from './../mixin/stopWatch'
  import tooltip from './../mixin/tooltip'
  import automation from './../mixin/automation'
  import moment from 'moment'
  import PTaskList from './shared/PTaskList'
  import draggable from 'vuedraggable'
  export default {
    mixins: [tooltip, stopWatch, methodTaskSocket, automation],
    components: {PTaskList, draggable},
    props: ['search', 'showFinalized', 'dontShowSubtasks', 'heightCardTask', 'individualFilterId'],
    data: () => ({
      allStatus: [],
      page: 0,
      loading: false,
      loadingAddTask: false,
      reOrdering: null,
      scrollLeft: 0,
      mount: false,
      dragOptions: {
        animation: 200,
        group: 'list',
        disabled: false
      }
    }),
    created () {
      this.$socket.emit('joinRoom', {room: `kanban${this.$auth.user().id}`})
      // this.reloadAllStatus()
    },
    destroyed () {
      this.$socket.emit('leaveRoom', {room: `kanban${this.$auth.user().id}`})
    },
    mounted () {
      // função para receber todos os valores de informações do kanban
      // this.reloadAllStatus()
    },
    // socket: {
    // },
    sockets: {
      // sockete para reload de um status especifico do kanban, ou varios, passado uma lista com Ids dos status a serem atualizados
      reloadStatusPage (statusId) {
        this.reloadStatus(statusId)
      },
      reloadAllStatusPage () {
        this.allStatus.forEach((status) => {
          let params = {
            taskBoardId: this.$store.getters[`selectedBoard/values`]['id'],
            status: status['id_text'],
            search: this.search,
            perPage: 8
          }
          this.$http.post(`api/get_filtered_tasks`, params).then(res => {
            Object.assign(status, {items: res.body['data'], to: res.body['to'], total: res.body['total'], loading: false})
          }, err => {
            console.log(err)
          })
        })
      },
      reloadStatusPageByName (statusNames) {
        this.allStatus.forEach((status) => {
          if (statusNames.includes(status.id_text)) {
            let params = {
              taskBoardId: this.$store.getters[`selectedBoard/values`]['id'],
              status: status['id_text'],
              search: this.search,
              perPage: 8
            }
            this.$http.post(`api/get_filtered_tasks`, params).then(res => {
              Object.assign(status, {items: res.body['data'], to: res.body['to'], total: res.body['total'], loading: false})
            }, err => {
              console.log(err)
            })
          }
        })
      }
    },
    methods: {
      // para reload de um status especifico do kanban, ou varios, passado uma lista com Ids dos status a serem atualizados
      reloadStatus (statusId) {
        this.allStatus.forEach((status) => {
          if (statusId.includes(status.id)) {
            let params = {
              taskBoardId: this.$store.getters[`selectedBoard/values`]['id'],
              status: status['id_text'],
              search: this.search,
              perPage: 8
            }
            this.$http.post(`api/get_filtered_tasks`, params).then(res => {
              Object.assign(status, {items: res.body['data'], to: res.body['to'], total: res.body['total'], loading: false})
            }, err => {
              console.log(err)
            })
          }
        })
      },
      reloadAllStatus (reset = false) {
        // metodo para atualização de todos os status
        this.loading = true
        this.$http.get(`api/get_kanban_status`).then(res => {
          this.allStatus = []
          // requestPerTime controla a quantidade de requisições que serão feitas a cada momento no kanban
          let requestPerTime = 3
          // Index controla os grupos de requests
          let index = 0
          let requests = []
          res.body.forEach(status => {
            this.allStatus.push(Object.assign(status, {to: 0, total: 0, items: [], loading: true, perPage: 8}))
            // separa os dados para fazer as requisições em grupos de acordo com a quantidade do requestPerTime
            if (index < requestPerTime) {
              // caso não seja array trasnforma em array
              if (!Array.isArray(requests[index])) requests[index] = []
              requests[index].push(status)
              index++
              // assim que o index chega no requestPerTime ele deve receber 0 para para voltar o processo
              if (index == requestPerTime) index = 0
            }
          })
          setTimeout(() => {
            requests.forEach(requestsStatusGroup => {
              this.requestStatusItens(requestsStatusGroup, 0, requestsStatusGroup.length)
            })
          }, 1000)
          this.loading = false
        })
      },
      requestStatusItens (requestsStatusGroup, indexCurrent, indexEnd) {
        // Quando o index corrente alcançar o fim para o processo
        if (indexCurrent >= indexEnd) return 0
        // pega os dados do status para fazer a busca
        let status = requestsStatusGroup[indexCurrent]
        let params = {
          taskBoardId: this.$store.getters[`selectedBoard/values`]['id'],
          status: status['id_text'],
          search: this.search,
          perPage: 8
        }
        // faz a busca dos itens de acordo com o status
        this.$http.post(`api/get_filtered_tasks`, params).then(res => {
          Object.assign(status, {items: res.body['data'], to: res.body['to'], total: res.body['total'], loading: false})
          // chama recrusivamente o requestStatusItens para buscar o proximo status que está no grupo dos requests
          this.requestStatusItens(requestsStatusGroup, indexCurrent + 1, indexEnd)
        }, err => {
          console.log(err)
          // Mesmo no erro continua o processo para terminar de carregar os que não foram carregados
          // chama recrusivamente o requestStatusItens para buscar o proximo status que está no grupo dos requests
          this.requestStatusItens(requestsStatusGroup, indexCurrent + 1, indexEnd)
          Object.assign(status, {items: [], loading: false})
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar os registros das ${this.translate('table.tasks.title')[1]}!`,
            color: 'error',
            dialog: true
          })
        })
      },
      getStatusItens (status) {
        let params = {
          taskBoardId: this.$store.getters[`selectedBoard/values`]['id'],
          status: status['id_text'],
          search: this.search,
          perPage: 8
        }
        this.$http.post(`api/get_filtered_tasks`, params).then(res => {
          Object.assign(status, {items: res.body['data'], to: res.body['to'], total: res.body['total'], loading: false})
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar os registros das ${this.translate('table.tasks.title')[1]}!`,
            color: 'error',
            dialog: true
          })
        })
      },
      insertTask (val) {
        this.$emit('doneNewTask', val)
      },
      // acionado quando é clicado no botão de adicionar do kanban ou quando adiciona um item com a consulta do kanban ativa
      insertIntoList (val) {
        let status = this.allStatus.find(st => st.id_text === val.status.id_text)
        if (status) {
          status.items.unshift(val)
          status.total = status.total + 1
        }
      },
      // edita qaundo edita um item com a consulta do kanban ativa
      editIntoList (task) {
        // mesmo processo feito no socket, caso seja necessário modificar
        if (task.old_status['id_text'] != task.status.id_text) {
          let oldStatus = this.allStatus.find(st => st.id_text === task.old_status['id_text'])
          if (oldStatus) {
            oldStatus.items = oldStatus.items.filter(val => val.id !== task.id)
            oldStatus.total = oldStatus.total - 1
          }
          let newStatus = this.allStatus.find(st => st.id_text === task.status.id_text)
          if (newStatus) {
            // uma verificação caso já exista algum item com aquele id, para não adicionar duplicado. Pois no methodEditTaskSocket do methodtaskSocket ao editar pode mandar um socket para adicionar e depois um de editar que pode acabar adicionando no kanban
            let index = newStatus.items.findIndex(it => it.id === task.id)
            if (index == -1) {
              newStatus.items.unshift(task)
              newStatus.total = newStatus.total + 1
            }
          }
        } else {
          let status = this.allStatus.find(st => st.id_text === task.status.id_text)
          if (status) {
            let index = status.items.findIndex(it => it.id === task.id)
            if (index != -1) Object.assign(status.items[index], task)
          }
        }
      },
      // quando é finalizada a tarefa pelo pSelectStatus
      finalizeTask (val) {
        // remoção da tarefa dos itens do status a ser removido
        let statusToBeRemoved = this.allStatus.find(st => st.id_text === val.task.status.id_text)
        if (statusToBeRemoved) {
          statusToBeRemoved.items = statusToBeRemoved.items.filter(item => item.id !== val.task.id)
          statusToBeRemoved.total = statusToBeRemoved.total - 1
        }
        // inserção e atualização da tarefa no novo status
        let statusToBeInserted = this.allStatus.find(st => st.id_text === val.status.id_text)
        if (statusToBeInserted) {
          val.task.status = {color: val.status.color, id: val.status.id, id_text: val.status.id_text, identifier: val.status.identifier}
          val.task.task_status_id = val.status.id
          statusToBeInserted.items.unshift(val.task)
          statusToBeInserted.total = statusToBeInserted.total + 1
        }
      },
      reloadExpandedStatus () {
        let expandeds = this.allStatus.filter(status => { return status.expanded })
        expandeds.map(status => {
          this.statusChangePage(status)
        })
      },
      deleteItem (item) {
        let statusToBeRemoved = this.allStatus.find(st => st.id_text === item.status.id_text)
        if (statusToBeRemoved) {
          statusToBeRemoved.items = statusToBeRemoved.items.filter(task => task.id !== item.id)
          statusToBeRemoved.total = statusToBeRemoved.total - 1
        }
      },
      // função feita para salvar a ordem dos status no filtros
      saveOrder (ev) {
        // montado a nova ordem de status
        let newOrder = []
        this.allStatus.forEach(status => {
          if (status.id === null) newOrder.push(0)
          else newOrder.push(status.id_text)
        })
        // para que não haja varias requisições só é salvo os valores no back e nos status do filtro assim que se passarem 2 segundos desde a ultima mudança
        clearTimeout(this.reOrdering)
        this.reOrdering = setTimeout(() => {
          this.$http.put('api/change_props_individual_filter/' + this.individualFilterId, {status: newOrder}).then(res => {
          }, err => {
            console.log(err)
            this.$store.commit('snackbar/change_values', {
              text: `Ocorreu um erro ao alterar as propriedades da ${this.translate('table.task_board.title')[0]}!`,
              color: 'error',
              dialog: true
            })
          })
        }, 2000)
      },
      openAddProcess (status) {
        this.loadingAddTask = true
        this.$store.dispatch('selectedBoard/propertiesAddTask').then((response) => {
          this.loadingAddTask = false
          if (response['openTask']) {
            this.$emit('createTask')
          } else {
            status.expanded = true
            let complementItem = response['values']
            setTimeout(() => {
              let defaultItem = Object.assign({identifier: '', user_id: this.$auth.user().id, user_index: '', connection_id: null, connection_company_id: null, team_id: '', category_id: '', client_id: '', task_status_id: '', id_text: '', begin: '', end: '', urgency: '', note: '', recurrence: {type: '', id_text: {each: '', days: '', months: '', daysToCreate: 1}}, password: '', shared: false, sons: [], identifier_sequence: '', level: 1}, complementItem, {task_status_id: status.id})
              // focus setado de acordo com o exibition type para q não ocorra conflitos
              // passado como parametro o defaultItem padrão de uma tarefa de nivel 1
              // task_status_id coloca no final também pois quando vem do kanban tem que pegar exatamente aquele status
              this.$refs[`list${status.id}`][0].openAddTask(defaultItem)
            }, 200)
          }
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar os registros, reporte o erro!`,
            color: 'error',
            dialog: true
          })
          this.$store.commit('loader/change_dialog', false)
        })
      },
      // função feita para o processo de drop de uma tarefa em um outro status
      changeStatusProcess (task, status) {
        // buscado os valores dos status antigo e novo
        let changeUserId = 0
        let changeUser = null
        let params = JSON.parse(this.$auth.user().company.params)
        if (params.hasOwnProperty('changeUser') && params['changeUser']['active'] && params['changeUser']['status'].some((value) => { return value == status.id })) {
          changeUserId = this.$auth.user().id
          changeUser = {}
          // inclui os valores no changeuser para mudar no front
          Object.assign(changeUser, {user_id: this.$auth.user().id, user: {id: this.$auth.user().id, id_text: this.$auth.user().id_text, email: this.$auth.user().email, photo_path: this.$auth.user().photo_path}})
        }
        // Muda o tempo antes de mudar o status pra não perder alguns segundos
        let taskValuesParamsTime = {id: task.element.id, id_text: task.element.id_text, task_status_id: status.id}
        this.companyParamsTime(taskValuesParamsTime)

        // Executa todas as alterações apenas no front
        let taskUpdated = status.items.find(ts => ts.id === task.element.id)
        // Before recebe valor pois caso de erro volta o valor antigo e para mandar os valores antigos para o socket para as comparações de user e status com os valores novos
        let beforeTaskUpdated = JSON.parse(JSON.stringify(taskUpdated))
        taskUpdated.status = {color: status.color, id: status.id, id_text: status.id_text, identifier: status.identifier}
        taskUpdated.task_status_id = status.id
        taskUpdated.status_date = moment().format('YYYY-MM-DD HH:mm:ss')
        // Caso tenha o changeUser significa que foi alterado para um status que deve altarar o responsável, portanto alterar o responsável no front
        if (changeUser) {
          Object.assign(taskUpdated, changeUser)
        }
        // requisição para alteração de status
        status.total = status.total + 1
        let changeValues = {'task_id': task.element.id, 'status_id_text': status.id_text, 'change_user': changeUserId}
        this.$http.post('api/change_status_kanban', changeValues).then(res => {
          taskUpdated['old_user_id'] = res.body['old_user_id']
          taskUpdated['participants'] = res.body['participants']
          taskUpdated['delTaskUsers'] = res.body['delTaskUsers']
          this.methodEditTaskSocket(taskUpdated, beforeTaskUpdated, false, true)
          // se tiver automações
          if (res.body['automations'].length > 0) {
            this.executeAutomations(task.element.id, res.body['automations'])
          }
          this.$store.commit('snackbar/change_values', {text: 'Status alterado com sucesso.', color: 'green', timeout: 2000, dialog: true})
        }, err => {
          // caso de erro volta as alterações antigas
          Object.assign(taskUpdated, beforeTaskUpdated)
          if (err.body.message === 'notFoundTask') {
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar. Recarregue a página e verifique se a tarefa ainda existe no sistema.', timeout: 10000, color: 'warning', dialog: true})
          } else if (err.body.message === 'actionDenied') {
            this.$store.commit('snackbar/change_values', {text: 'Apenas os administradores da empresa, responsáveis da equipe ou o responsável da tarefa podem edita-la.', color: 'warning', timeout: 10000, dialog: true})
          } else if (err.body.message === 'notStatus') {
            this.$store.commit('snackbar/change_values', {text: 'Não existe o status ' + status.id_text + ' na empresa da tarefa.', color: 'warning', timeout: 10000, dialog: true})
          } else if (err.body.message === 'hasDependency') {
            this.$store.commit('snackbar/change_values', {text: 'Para finalizar essa tarefa, todos os pré-requisitos devem ser finalizados.', color: 'warning', timeout: 10000, dialog: true})
          } else if (err.body.message === 'dependentFinalized') {
            this.$store.commit('snackbar/change_values', {text: 'Para alterar o status desta tarefa, ela não pode ser pré-requisito de uma tarefa já finalizada.', color: 'warning', timeout: 10000, dialog: true})
          } else {
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
          }
          status.items = status.items.filter(item => {
            return item.id !== task.element.id
          })
          let oldStatus = this.allStatus.find(status => status.id_text.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') === task.element.status.id_text.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
          oldStatus.items.unshift(task.element)
        })
      },
      // toggle para expandir o kanban
      expandToggle (status) {
        // invert o valor no status
        status.expanded = !status.expanded
        let retainedIds = []
        // percorre os status e verifica quais estatos estão retraidos para adicionar no banco
        this.allStatus.forEach((val) => {
          if (!val.expanded) retainedIds.push(val['id'])
        })
        // setTimeout para dar tempo de verificar os status acima
        setTimeout(() => {
          this.$http.put('api/change_props_individual_filter/' + this.individualFilterId, {retained: retainedIds}).then(res => {
          }, err => {
            console.log(err)
            this.$store.commit('snackbar/change_values', {
              text: `Ocorreu um erro ao alterar as propriedades da ${this.translate('table.task_board.title')[0]}!`,
              color: 'error',
              dialog: true
            })
          })
        }, 100)
      },
      // função para expansão da lista de um status apos clicar em mostrar mais
      statusChangePage (status, add = false) {
        if (add) status.perPage = status.perPage + 8
        status.loading = true
        let params = {
          taskBoardId: this.$store.getters[`selectedBoard/values`]['id'],
          status: status.id_text,
          search: this.search,
          perPage: status.perPage
        }
        this.$http.post(`api/get_filtered_tasks`, params).then(res => {
          Object.assign(status, {items: res.body['data'], to: res.body['to'], total: res.body['total'], loading: false})
          status.loading = false
        })
      },
      // função utilizado para reload de mais de uma lista de itens, a função só altera os items mantendo informações secundarias como expanded page e etc
      compareStatus (a, b) {
        let statusA = a.id_text.toUpperCase()
        let statusB = b.id_text.toUpperCase()
        let identA = a.identifier === null ? -1 : a.identifier
        let identB = b.identifier === null ? -1 : b.identifier
        let comparison = 0
        if (identA + identB !== -2) {
          comparison = identA > identB ? -1 : -2
        } else if (statusA > statusB) {
          comparison = 1
        } else if (statusA < statusB) {
          comparison = 2
        }
        return comparison
      },
      sequenceExpanded (sequence) {
        var sequenceExpandedIds = this.sequenceExpandedIds + (sequence ? `.${sequence}` : '')
        this.$emit('sequenceExpanded', sequenceExpandedIds)
      },
      createSubItem: function (item) {
        this.$emit('createSubItem', item)
      },
      duplicateTask: function (id) {
        this.$emit('duplicateTask', id)
      },
      editSubItem: function (item, view) {
        this.$emit('editSubItem', item, view)
      },
      deleteSubItem: function (item) {
        this.$emit('deleteSubItem', item)
      }
    }
  }
</script>

<style scoped>
  .list_container {
    direction: ltr !important;
    overflow: auto !important;
    display: flex !important;
  }
  
  .top-hr {
    border: 0;
    margin-top: 5px;
    margin-bottom: 5px;
    border-radius: 5px 5px 3px 3px;
    box-shadow: 0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12)
  }

  .content_kanban {
    margin: 0 10px 0 0;
  }

  .content_kanban .item_direction .layout .handle {
    cursor:grab;
    padding: 15px;
    /* margin-right: 10px; */
  }
  .sortable-chosen .item_direction .layout .handle {
    cursor:grabbing;
    padding: 15px;
    /* margin-right: 10px; */
  }
  
  .item_direction {
    float: left;
    border: solid 2px;
    border-radius: 3px 3px 10px 10px;
    border-top-width: 10px;
    /* border-radius: 10px 10px 10px 10px; */
  }
</style>


// WEBPACK FOOTER //
// src/components/Kanban.vue